import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{

  path: '/',
  name: 'layout',
  component: () => import('../components/LayoutPage.vue'),
  redirect: '/home',
  children: [{
    path: '/home',
    name: 'home',
    component: () => import('../views/Home/HomePage.vue'),
    meta: {
      name: '首页',
      keep: true
    }
  },
  {
    path: '/appver',
    name: 'appver',
    component: () => import('../views/AppVer/AppVer.vue'),
    meta: {
      name: '版本控制',
      keep: true
    }
  },
  {
    path: '/emergency',
    name: 'emergency',
    component: () => import('../views/Emergency/Emergency.vue'),
    meta: {
      name: '紧急控制',
      keep: true
    }
  },
  {
    path: '/systemagent',
    name: 'systemagent',
    component: () => import('../views/System/SystemAgent/SystemAgent.vue'),
    meta: {
      name: '系统助手',
      keep: true
    }
  },
  {
    path: '/officialwebsite',
    name: 'officialwebsite',
    component: () => import('../views/OfficialWebsite/OfficialWebsite.vue'),
    meta: {
      name: '官网公告',
      keep: true
    }
  },

  {
    path: '/usermanagement',
    name: 'usermanagement',
    component: () => import('../views/User/UserManagement/UserManagement.vue'),
    meta: {
      name: '用户列表',
      fname: '用户管理',
      keep: true
    }
  },

  {
    path: '/userexception',
    name: 'userexception',
    component: () => import('../views/User/UserException/UserException.vue'),
    meta: {
      name: '异常用户',
      fname: '用户管理',
      keep: true
    }
  },
  {
    path: '/usercomplaint',
    name: 'usercomplaint',
    component: () => import('../views/User/UserComplaint/UserComplaint.vue'),
    meta: {
      name: '用户申诉',
      fname: '用户管理',
      keep: true
    }

  },
  {
    path: '/userreport',
    name: 'userreport',
    component: () => import('../views/User/UserReport/UserReport.vue'),
    meta: {
      name: '用户举报',
      fname: '用户管理',
      keep: true
    }
  },
  {
    path: '/userlogout',
    name: 'userlogout',
    component: () => import('../views/User/UserLogout/UserLogout.vue'),
    meta: {
      name: '注销用户',
      fname: '用户管理',
      keep: true
    }
  },
  {
    path: '/userdonelogout',
    name: 'userdonelogout',
    component: () => import('../views/User/UserDoneLogout/UserDoneLogout.vue'),
    meta: {
      name: '已注销用户',
      fname: '用户管理',
      keep: true
    }

  },
  {
    path: '/groupmanagement',
    name: 'groupmanagement',
    component: () => import('../views/Group/GroupManagement/GroupManagement.vue'),
    meta: {
      name: '群组管理',
      keep: true
    }
  },

  {
    path: '/rechargerecord',
    name: 'rechargerecord',
    component: () => import('../views/Financial/RechargeRecord/RechargeRecord.vue'),
    meta: {
      name: '充值记录',
      fname: '财务管理',
      keep: true
    }
  },
  {
    path: '/rechargerecord-v2',
    name: 'rechargerecordv2',
    component: () => import('../views/Financial/RechargeRecordV2/RechargeRecord.vue'),
    meta: {
      name: '充值记录(kd)',
      fname: '财务管理(kd)',
      keep: true
    }
  },
  {
    path: '/withdrawalsrecord',
    name: 'withdrawalsrecord',
    component: () => import('../views/Financial/WithdrawalsRecord/WithdrawalsRecord.vue'),
    meta: {
      name: '提现记录',
      fname: '财务管理',
      keep: true
    }
  },
  {
    path: '/withdrawalsrecord-v2',
    name: 'withdrawalsrecordv2',
    component: () => import('../views/Financial/WithdrawalsRecordV2/WithdrawalsRecord.vue'),
    meta: {
      name: '提现记录(kd)',
      fname: '财务管理',
      keep: true
    }
  },
  {
    path: '/opinionmanagement',
    name: 'opinionmanagement',
    component: () => import('../views/OpinionManagement/OpinionManagement.vue'),
    meta: {
      name: '意见管理',
      keep: true
    }
  },
  {
    path: '/changepassword',
    name: 'changepassword',
    component: () => import('../views/User/ChangePassword/ChangePassword.vue'),
    meta: {
      name: '修改密码',
      keep: true
    }
  },
  {


    path: '/helpmanage',
    name: 'helpmanage',
    component: () => import('../views/HelpManage/HelpManage.vue'),
    meta: {
      name: '帮助管理',
      keep: true
    }
  },
  {
    path: '/kefulist',
    name: 'kefulist',
    component: () => import('../views/KefuList/KefuList.vue'),
    meta: {
      name: '客服列表',
      keep: true
    }

  },
  {
    path: '/roboticspeech',
    name: 'roboticspeech',
    component: () => import('../views/RoboticSpeech/RoboticSpeech.vue'),
    meta: {
      name: '机器人话术管理',
      keep: true
    }

  },
  {
    path: '/cashtask',
    name: 'cashtask',
    component: () => import('../views/Money/CashTask/CashTask.vue'),
    meta: {
      name: '提现任务',
      keep: true
    }

  },
  {
    path: '/cashtask-v2',
    name: 'cashtaskv2',
    component: () => import('../views/Money/CashTaskV2/CashTask.vue'),
    meta: {
      name: '提现任务(kd)',
      keep: true
    }

  },
  {
    path: '/checkbill',
    name: 'checkbill',
    component: () => import('../views/Money/CheckBill/CheckBill.vue'),
    meta: {
      name: '查询账单',
      keep: true
    }
  },
  {

    path: '/redenvelope',
    name: 'redenvelope',
    component: () => import('../views/Money/RedEnvelope/RedEnvelope.vue'),
    meta: {
      name: '红包管理',
      keep: true

    }
  },
  {


    path: '/transfermanagement',
    name: 'transfermanagement',
    component: () => import('../views/Transfer/TransferManagement/TransferManagement.vue'),
    meta: {
      name: '转账管理',
      keep: true

    }
  },
  {

    path: '/groupmember',
    name: 'groupmember',
    component: () => import('../views/Group/GroupMember/GroupMember.vue'),
    meta: {
      name: '群员管理',
      keep: true

    }
  },
  {

    path: '/dailybill',
    name: 'dailybill',
    component: () => import('../views/Money/DailyBill/DailyBill.vue'),
    meta: {
      name: '每日账单',
      keep: true

    }
  },
  {

    path: '/configurationma',
    name: 'configurationma',
    component: () => import('../views/ConfigurationMa/ConfigurationMa.vue'),
    meta: {
      name: '配置管理',
      keep: true

    }
  },
  {
    path: '/transferconfiguration',
    name: 'transferconfiguration',
    component: () => import('../views/Transfer/TransferConfiguration/TransferConfiguration.vue'),
    meta: {
      name: '转账配置',
      keep: true

    }
  },

  {
    path: '/shopattr',
    name: 'ShopAttr',
    component: () => import('../views/Shop/ShopAttr/ShopAttr.vue'),
    meta: {
      name: '属性管理',
      keep: true

    }
  },

  {
    path: '/commodityma',
    name: 'commodityma',
    component: () => import('../views/Shop/CommodityMa/CommodityMa.vue'),
    meta: {
      name: '商品管理',
      keep: true

    }
  },
  {
    path: '/mallfeedback',
    name: 'mallfeedback',
    component: () => import('../views/Shop/MallFeedback/MallFeedback.vue'),
    meta: {
      name: '商城反馈',
      keep: true

    }
  }, {
    path: '/carousel',
    name: 'carousel',
    component: () => import('../views/Shop/CarouselPage/CarouselPage.vue'),
    meta: {
      name: '轮 播 图',
      keep: true

    }
  }, {
    path: '/addressma',
    name: 'addressma',
    component: () => import('../views/Shop/AddressMa/AddressMa.vue'),
    meta: {
      name: '收货管理',
      keep: true

    }
  }, {
    path: '/shoppingcart',
    name: 'shoppingcart',
    component: () => import('../views/Shop/ShoppingCart/ShoppingCart.vue'),
    meta: {
      name: '购 物 车',
      keep: true

    }
  }, {
    path: '/orderma',
    name: 'orderma',
    component: () => import('../views/Shop/OrderMa/OrderMa.vue'),
    meta: {
      name: '订单管理',
      keep: true

    }
  }, {
    path: '/Websiteurl',
    name: 'Websiteurl',
    component: () => import('../views/System/WebsiteURL/WebsiteURL.vue'),
    meta: {
      name: '网站URL配置',
      keep: true

    }
  }, {
    path: '/vipma',
    name: 'vipma',
    component: () => import('../views/VipManagment/VipManagment.vue'),
    meta: {
      name: 'VIP管理',
      keep: true

    }
  },
  {

    path: '/recharge',
    name: 'recharge',
    component: () => import('../views/Money/RechargePage/RechargePage.vue'),
    meta: {
      name: '充值记录',
      keep: true

    }
  },
  {

    path: '/useramount',
    name: 'useramount',
    component: () => import('../views/Financial/UserAmount/UserAmount.vue'),
    meta: {
      name: '账单统计',
      keep: true

    }
  },

  {

    path: '/useramount-v2',
    name: 'useramountv2',
    component: () => import('../views/Financial/UserAmountV2/UserAmount.vue'),
    meta: {
      name: '账单统计(kd)',
      keep: true

    }
  },

  {

    path: '/buylist',
    name: 'buylist',
    component: () => import('../views/TransactionManage/BuyList/index.vue'),
    meta: {
      name: '购买列表',
      keep: true
    }
  }
    , {

    path: '/datatotal',
    name: 'datatotal',
    component: () => import('../views/TransactionManage/DataTotal/index.vue'),
    meta: {
      name: '数据统计',
      keep: true
    }
  }
    ,
  {

    path: '/selllist',
    name: 'selllist',
    component: () => import('../views/TransactionManage/SellList/index.vue'),
    meta: {
      name: '出售列表',
      keep: true

    }
  }
    ,
  {

    path: '/appeallist',
    name: 'appeallist',
    component: () => import('../views/TransactionManage/AppealList/index.vue'),
    meta: {
      name: '申诉列表',
      keep: true

    }
  }
  ]
},

{
  path: '/login',
  name: 'login',
  component: () => import('../views/Login/LoginPage.vue')
}
]

const router = new VueRouter({
  routes,
  mode:'history'
})

router.beforeEach((to, from, next) => {
  next()

  // let Token = sessionStorage.getItem('token')
  // if (to.path !== '/login' && !Token) {
  //   next("/login")
  // } else {
  //   next()
  // }
})


export default router